import { useMutation } from "@apollo/client/react";
import React, { useState } from 'react';

import toast from 'react-hot-toast';
import { SOLICITAR_CORRECCION } from '../../../../data/graphQL/mutations/Contratos/solicitarCorreccion';
import { CustomDialog } from "../../../../components/customDialog/CustomDialog";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';
import { Grid } from '@mui/material';

export const SolicitarCorreccionInput = ({ idEvaluacion, column, disabled, onCompletedSolicitarCorreccion }) => {
  const [openModal, setOpenModal] = useState(false);
  const [observacion, setObservacion] = useState('');

  const handleOpenModal = () => setOpenModal(true);
  const handleClose = () => {setOpenModal(false);setObservacion('');};

  const [solicitarCorreccion, { loading: loadingCorreccion }] = useMutation(SOLICITAR_CORRECCION, {
    fetchPolicy: 'no-cache',
    variables: { idEvaluacion, observacion },
    onCompleted: () => {
      onCompletedSolicitarCorreccion();
    }
  });

  const handleAccept = () => {
    if (!observacion) {
      toast.error('Debe ingresar una observación');
      return;
    }

    toast.promise(solicitarCorreccion(), {
      loading: 'Solicitando corrección...',
      success: 'Se ha ejecutado la solicitud de corrección',
      error: 'Ha ocurrido un error al solicitar la corrección'
    });

    setOpenModal(false);
  };

  return (
    <>
            <Grid size={{ xs: 100, md: column }}>
                <CustomButton
          label={'Solicitar Modificación'}
          variant='outlined'
          onClick={() => {handleOpenModal();}}
          isLoading={loadingCorreccion}
          disabled={loadingCorreccion || disabled} />
        
            </Grid>
            {/* <RenderInputsRowByType
               input={{
                   displayName: 'Solicitar Modificación',
                   name: 'solicitarModificacion',
                   type: 'button',
                   isLoading: loadingCorreccion,
                   variant: 'outlined',
                   col: column,
                   onClick: handleOpenModal
               }}
               value={null}
               handleChange={null}
           /> */}
            <CustomDialog
        maxWidth='sm'
        fullWidth
        onCancel={() => handleClose()}
        onAccept={() => handleAccept()}
        open={openModal}
        cancelText='Cancelar'
        acceptText='Aceptar'
        title={'Solicitud de Modificación/Corrección'}>
        
                <RenderInputsRowByType
          input={{
            displayName: 'Observación',
            name: 'observacion',
            type: 'long_string',
            col: 100
          }}
          value={observacion}
          handleChange={(_, value) => setObservacion(value)} />
        
            </CustomDialog>
        </>);

};